import { render, staticRenderFns } from "./UpsellSideNav.vue?vue&type=template&id=d180e4a6&scoped=true&"
import script from "./UpsellSideNav.vue?vue&type=script&lang=js&"
export * from "./UpsellSideNav.vue?vue&type=script&lang=js&"
import style0 from "./UpsellSideNav.vue?vue&type=style&index=0&id=d180e4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d180e4a6",
  null
  
)

export default component.exports